import { Component } from "react";
import { appContext } from "../../AppContext";
import "../../styles/css/dashboard.scss";
import "../../App.css";

class AccessDenied extends Component
{
  private labels = appContext().labels;

  public render(): JSX.Element
  {
    return (
      <div className="content">
        <div className="page-title mb-20">
          <h1> {this.labels.HubLabelaccessDeniedLabel}</h1>
        </div>
        <div className="row">
          <div className="col-12 card ml-0">
            <h3>{this.labels.HubLabelaccessDenied}</h3>
          </div>
        </div>
      </div>
    );
  }
}

export default AccessDenied;
